import Skeleton from '@mui/material/Skeleton';

export { Skeleton };
